import React from 'react';
import styled from 'styled';
import { QueryProps } from '../use-query';

type Props = {
  query: QueryProps;
}

const StyledSection = styled.section`
  display: flex;
  flex-direction: row;
  gap: .75em;
  align-items: center;
  justify-content: flex-start;

  h3, p {
    margin: 0;
    padding-right: .75em;
  }

  h3 {
    &::before {
      content: "SITE: "
    };
    font-size: ${({ theme }) => theme.font.size.small};
    text-transform: uppercase;
  }

  p::before {
    content: "Tour: "
  }

  ul {
    list-style-type: none;
    margin-block-start: 0;
    margin-block-end: 0;
    margin-inline-start: 0;
    margin-inline-end: 0;
    padding-inline-start: 0;
    
    li { 
      display: inline-block;
      padding-right: .5em;

      &:first-child::after {
        content: '-';
        width: 1em;
        height: 1em;
        padding-left: .5em;
      }
      
    }
  }
`

const getLocaleDateString = (dateObj: Date | null) =>
    dateObj ? dateObj.toLocaleDateString() : '...';

export const QuerySummary: React.FC<Props> = ({query}) => (
  <StyledSection>
    <h3>{query.metadata.siteName}</h3>
    <p>{query.metadata.tourName}</p>
    <ul>
      <li>{getLocaleDateString(query.fromDate)}</li>
      <li>{getLocaleDateString(query.toDate)}</li>
    </ul>
  </StyledSection>
  );